"use client";

import { cn, Icon } from "@kyan/ui";
import { motion } from "motion/react";

import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";

import { getTradePanelTransition } from "../../utils/getPanelTransition";

export const ToggleButton: React.FC = () => {
  const { showTradePanel, setShowTradePanel } = useShowTradePanel();

  const handleToggle = () => {
    setShowTradePanel((previous) => !previous);
  };

  return (
    <motion.button
      transition={getTradePanelTransition(showTradePanel)}
      animate={{
        left: showTradePanel ? "auto" : "-1rem",
        right: showTradePanel ? "1rem" : "auto",
      }}
      className={cn(
        "border-divider bg-background hover:text-textPrimary absolute top-4 flex h-7 w-24 cursor-pointer items-center gap-2 rounded-sm border px-4 transition-colors",
        {
          "flex-row-reverse": showTradePanel,
        },
      )}
      onClick={handleToggle}
    >
      <Icon
        name="caret-down"
        className={cn("text-xxs transition-transform", {
          "rotate-90": !showTradePanel,
          "-rotate-90": showTradePanel,
        })}
      />
      <span className="text-xs">{showTradePanel ? "Collapse" : "Open"}</span>
    </motion.button>
  );
};
